import { getLSItem } from "v4/services/localStorage.service";
import { NOTIFY_ME_STORAGE_KEY } from "v4/components/utils/NotifyMe/hooks/useNotifyMe";

const DEFAULTS = {
    icon: '/images/POL.png',
    tag: 'pol-notification',
};

/**
 * @param {string} title
 * @param {{ body?: string, icon?: string, tag?: string, badge?: string, silent?: boolean, requireInteraction?: boolean }} options
 */
export function sendBrowserNotification(title, options = {}) {
    if (!('Notification' in window)) return;
    if (Notification.permission !== 'granted') return;
    if (getLSItem(NOTIFY_ME_STORAGE_KEY, 'string') !== 'enabled') return;

    new Notification(title, { ...DEFAULTS, ...options });
}
